import React, { useEffect, useMemo, useState } from 'react';
import styles from './ThresholdMarketingProgress.styles';
import {
  calculateThresholdProgress,
  formatRemainingPrice,
  getTitleFromOffer,
  isThresholdCampaignValid,
} from './ThresholdMarketingProgress.service';
import { useAppSelector } from '../../redux/hook';
import { MarketingCampaignType, Offer, ThresholdMarketingCampaignConfig, } from '../../1_types/genericTypes';
import ProgressBar from '../ProgressBar/ProgressBar.view';
import _ from 'lodash';

export type ThresholdMarkertingProgressProps = {
  offer: Offer;
};

export default function ThresholdMarketingProgress({
  offer,
}: ThresholdMarkertingProgressProps) {
  const { isMobile } = useAppSelector((state) => state.componentReducer);
  const {
    totalProductPriceWithPromo,
    orderType,
    commande,
  } = useAppSelector((state) => state.pendingOrderReducer);

  const [errorOccured, setErrorOccured] = useState(false);

  const config = offer.config as ThresholdMarketingCampaignConfig;
  const isValid = isThresholdCampaignValid(offer, orderType);

  const currentAmountForThreshold = useMemo(() => totalProductPriceWithPromo ?? 0, [totalProductPriceWithPromo]);

  const isComplete = currentAmountForThreshold >= config.threshold;

  useEffect(() => {
    if (isComplete) setErrorOccured(false);
  }, [isComplete]);

  const progressLabel = useMemo(() => {
    const remainingAmount = config.threshold - currentAmountForThreshold;

    if (isComplete || remainingAmount <= 0) {
      return 'Promotion débloquée !';
    }

    const formattedRemaining = formatRemainingPrice(remainingAmount);
    return `Plus que ${formattedRemaining} pour débloquer ta promo !`;
  }, [isComplete, currentAmountForThreshold, config.threshold]);

  return !isValid || errorOccured ? (
    <></>
  ) : (
    <div
      style={{
        ...styles.floatingThresholdProgressContainer,
        ...(isMobile && !_.isEmpty(commande) ? { bottom: 65, left: 10 } : {}),
      }}
    >
      <div style={styles.floatingThresholdTitleContainer}>
        <img
          src='/assets/thresholdMarketing.png'
          height={26}
          width={26}
        />
        <div>
          <p style={styles.floatingThresholdTitle}>
            {getTitleFromOffer(offer)}
          </p>
          {offer.type ===
            MarketingCampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD && (
            <p style={styles.floatingThresholdSubTitle}>
              *Sur une sélection de produits
            </p>
          )}
        </div>
      </div>
      <div style={{ width: '100%', padding: '0 12px 12px 12px' }}>
        <ProgressBar
          isComplete={isComplete}
          progress={calculateThresholdProgress(
            currentAmountForThreshold,
            config.threshold,
          )}
          label={progressLabel}
        />
      </div>
    </div>
  );
}
